import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { CheckComponent } from '../../../icons/check/check.component';
import { pascalCaseToWords } from '../../../../common/common-utils';
import { TrReviewStats } from '../../../../../shared/models/internal/details/tr-review-stats';

@Component({
  selector: 'app-tr-review-stats',
  imports: [CheckComponent],
  templateUrl: './tr-review-stats.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tr-review-stats.component.scss',
})
export class TrReviewStatusComponent implements OnChanges {
  @Input() public trReviewsStats?: TrReviewStats[];

  public everythingReviewed = false;
  public displayTerminalColumn = true;
  public displayDocumentationColumn = true;

  protected pascalCaseToWords = pascalCaseToWords;

  public ngOnChanges(): void {
    if (!this.trReviewsStats) {
      this.everythingReviewed = false;
    }

    this.everythingReviewed =
      this.trReviewsStats?.every(
        (item) =>
          (!item.reviewedTerminalCount || item.reviewedTerminalCount === item.totalCount) &&
          (!item.reviewedDocumentationCount || item.reviewedDocumentationCount === item.totalCount)
      ) ?? false;
    this.displayTerminalColumn = this.trReviewsStats?.some((item) => item.reviewedTerminalCount) ?? false;
    this.displayDocumentationColumn = this.trReviewsStats?.some((item) => item.reviewedDocumentationCount) ?? false;
  }
}
